module.exports = __webpack_public_path__ + "img/sprite-icon-new.bf1c2a7d.png";